import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  Lottie,
} from '@uncinc/uncinc-react-kitchen-sink';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import lottieArrow from '../../../../assets/lotties/arrow-right/data.json';

import './style.scss';

const LottieArrowMemo = React.memo(({ lottie, lottieRef }) => {
  return (
    <Lottie
      id={`help_teaser_arrow-${Math.floor(Math.random() * (1000 - 2 + 1) + 2)}`}
      key="test"
      className="NodeHelpPageTeaser__lottie__lottie"
      data={lottie}
      ref={lottieRef}
      loop={false}
      autoPlay={false}
      startPosition={0}
      pauseOnClick={false}
      onInit={(instance) => {
        instance.addEventListener('complete', () => {
          instance.goToAndStop(0);
        });
      }}
    />
  );
});


const NodeHelpPageTeaser = ({ entity }) => {
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));
  const lottieAnimation = useRef(null);
  const [mousePositionRelativeX, setMousePositionRelativeX] = useState(0);
  const [mousePositionRelativeY, setMousePositionRelativeY] = useState(0);
  const path = entity.getIn(['paths', currentLanguage]);

  const title = entity.getIn(['title', 0, 'value']);

  const helpPageType = entity.getIn(['field_help_page_type', 0, 'entity', 'name', 0, 'value']);
  const innerClasses = c(`NodeHelpPageTeaser__inner NodeHelpPageTeaser__inner--${helpPageType.toLowerCase()}`);


  const onMouseEnterFill = (e) => {
    // Determine the mouse position relative to the current Lottie.
    const clientRect = e.target.getBoundingClientRect();
    setMousePositionRelativeX(e.type === 'touchmove' ? (
      (e.touches[0].clientX - clientRect.left) / clientRect.width * 100
    ) : (
      (e.clientX - clientRect.left) / clientRect.width * 100
    ));
    setMousePositionRelativeY(e.type === 'touchmove' ? (
      (e.touches[0].clientY - clientRect.top) / clientRect.height * 100
    ) : (
      (e.clientY - clientRect.top) / clientRect.height * 100
    ));
  };

  const onMouseExitFill = (e) => {
    // Determine the mouse position relative to the current Lottie.
    const clientRect = e.target.getBoundingClientRect();
    setMousePositionRelativeX(e.type === 'touchmove' ? (
      (e.touches[0].clientX - clientRect.left) / clientRect.width * 100
    ) : (
      (e.clientX - clientRect.left) / clientRect.width * 100
    ));
    setMousePositionRelativeY(e.type === 'touchmove' ? (
      (e.touches[0].clientY - clientRect.top) / clientRect.height * 100
    ) : (
      (e.clientY - clientRect.top) / clientRect.height * 100
    ));
  };

  const onMouseEnter = (e) => {
    if (lottieAnimation && lottieAnimation.current) {
      lottieAnimation.current.play();
    }

    onMouseEnterFill(e);
  };

  return (
    <div className="NodeHelpPageTeaser">
      <div className={innerClasses} onMouseEnter={onMouseEnter} onMouseLeave={onMouseExitFill}>
        <CoreLink className="NodeHelpPageTeaser__link" to={path} />
        <div
          className="NodeHelpPageTeaser__circle"
          style={{
            left: `${mousePositionRelativeX}%`,
            top: `${mousePositionRelativeY}%`,
          }}
        />
        <h3 className="NodeHelpPageTeaser__title">{title}</h3>
        <div className="NodeHelpPageTeaser__lottie">
          <LottieArrowMemo lottie={lottieArrow} lottieRef={lottieAnimation} />
        </div>
      </div>
    </div>
  );
};

export default NodeHelpPageTeaser;
